module.exports = __webpack_public_path__ + "img/picon4.8ec4decb.png";